var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._b({attrs:{"rules":_vm.rules,"no-resize":"","name":"message","label":"Mensagem"}},'v-textarea',_vm.fieldProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }